import React from "react";
import { FiArrowLeft, FiLock, FiTrash2, FiTruck } from "react-icons/fi";
import { Link } from "react-router-dom";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Button from "../components/common/Button";
import EmptyState from "../components/common/EmptyState";
import PageMeta from "../components/common/PageMeta";
import QuantityPicker from "../components/common/QuantityPicker";
import siteConfig, { formatCurrency } from "../config/siteConfig";
import { useCommerce } from "../hooks/useCommerce";

const CartPage = () => {
  const { cartItems, updateQuantity, removeFromCart, subtotal, shipping, total, freeSample, setFreeSample } = useCommerce();

  if (!cartItems.length) {
    return <div className="cart-page"><PageMeta title="Your Cart" /><EmptyState title="Your cart is waiting for flavor" description="Explore the pantry and choose a jar for your next meal." actionLabel="Shop all spices" actionTo="/shop" /></div>;
  }

  return (
    <div className="cart-page">
      <PageMeta title="Your Cart" description={`Review your ${siteConfig.displayName} pantry selections.`} />
      <div className="site-container">
        <Breadcrumbs items={[{ label: "Home", href: "/" }, { label: "Cart" }]} />
        <header className="page-heading"><p className="eyebrow">Your selections</p><h1>Shopping cart</h1><p>{cartItems.length} {cartItems.length === 1 ? "line" : "lines"} in your pantry box.</p></header>
        <div className="cart-page__layout">
          <section className="cart-lines" aria-label="Cart items">
            <div className="free-shipping-meter">
              <div><FiTruck aria-hidden="true" /><span><strong>Flat-rate standard shipping: {formatCurrency(siteConfig.shipping.standardRate)}</strong></span></div>
              <span className="free-shipping-meter__track"><span style={{ width: "100%" }} /></span>
            </div>
            <ul>
              {cartItems.map((item) => (
                <li className="cart-line" key={item.lineId}>
                  <Link className="cart-line__image" to={`/products/${item.product.slug}`}><img src={item.image} alt={item.product.name} /></Link>
                  <div className="cart-line__details">
                    <p className="eyebrow">{item.product.category}</p>
                    <Link to={`/products/${item.product.slug}`}><h2>{item.product.name}</h2></Link>
                    <p>{item.variantLabel} · {item.variantWeight}</p>
                    <div className="cart-line__mobile-price">{formatCurrency(item.lineTotal)}</div>
                    <div className="cart-line__actions">
                      <QuantityPicker value={item.quantity} onChange={(quantity) => updateQuantity(item.lineId, quantity)} max={item.variant?.stock || 99} label={`Quantity for ${item.product.name}`} />
                      <button type="button" onClick={() => removeFromCart(item.lineId)}><FiTrash2 aria-hidden="true" /> Remove</button>
                    </div>
                  </div>
                  <strong className="cart-line__price">{formatCurrency(item.lineTotal)}</strong>
                </li>
              ))}
            </ul>
            <Link className="cart-page__continue" to="/shop"><FiArrowLeft aria-hidden="true" /> Continue shopping</Link>
          </section>
          <aside className="cart-summary">
            <p className="eyebrow">Order summary</p><h2>Your pantry box</h2>
            <label htmlFor="free-sample">Choose a complimentary sample</label>
            <select id="free-sample" value={freeSample} onChange={(event) => setFreeSample(event.target.value)}>
              <option value="surprise">Surprise me</option><option value="smoky">Something smoky</option><option value="bright">Something bright</option><option value="warm">Something warm</option>
            </select>
            <dl><div><dt>Subtotal</dt><dd>{formatCurrency(subtotal)}</dd></div><div><dt>Standard shipping</dt><dd>{shipping === 0 ? "Free" : formatCurrency(shipping)}</dd></div><div className="cart-summary__total"><dt>Estimated total</dt><dd>{formatCurrency(total)}</dd></div></dl>
            <p className="cart-summary__tax">Taxes calculated at checkout.</p>
            <Button to="/checkout" fullWidth size="large"><FiLock aria-hidden="true" /> Secure checkout</Button>
            <div className="cart-summary__trust"><FiLock aria-hidden="true" /><span><strong>Secure checkout</strong><small>Your payment details are handled by your future payment provider.</small></span></div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
